'use client';
import { useEffect } from 'react';

import { useBotPaywallContext } from '~context/botPaywall';
import { useHasSubscription } from '~features/tags';

import { useNeedsToShowBotPaywall } from './useNeedsToShowBotPaywall';

export const useShowBotPaywall = ({ recipientId }: { recipientId: string }) => {
	const { requestedPaywallBotData, setNeedsToShowBotPaywall } =
		useNeedsToShowBotPaywall();
	const { openBotPaywall } = useBotPaywallContext();
	const [hasSubscription] = useHasSubscription();

	useEffect(() => {
		if (
			!!recipientId &&
			requestedPaywallBotData?.botId === recipientId &&
			!hasSubscription
		) {
			openBotPaywall({
				reason: requestedPaywallBotData.reason,
				reasonType: requestedPaywallBotData.reasonType,
			});
			setNeedsToShowBotPaywall(undefined);
		}
	}, [
		recipientId,
		hasSubscription,
		requestedPaywallBotData,
		openBotPaywall,
		setNeedsToShowBotPaywall,
	]);
};
